import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import ecommerceImg from "../../../assets/ecommercebg.avif";
import "./Ecommerce.css";
import electronics from "../../../assets/electronics.jpg";
import home from "../../../assets/home.jpg";
import fashion from "../../../assets/fashion.jpg";
import beauty from "../../../assets/beauty.jpg";
import toys from "../../../assets/toys.jpg";
import sports from "../../../assets/sports.jpg";

const Ecommerce = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="ecommerce">
      <div className="hero-banner">
        <div className="overlay"></div>

        <Container className="text-center d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="fade-up ">Welcome to SHIVEK E-COMMERCE</h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Your ultimate destination for high-quality products across a wide range of categories. As a fast-growing eCommerce
            business, we take pride in offering over 100+ product listings on some of the most trusted platforms like Amazon, Flipkart, Meesho, and more. Our mission is to provide our customers with products that are not only loved but highly repurchased.
          </p>
          <Button
            variant="primary"
            href="#categories"
            size="lg"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Explore Categories
          </Button>
        </Container>
      </div>

      <Container className="my-5" id="about-us">
        <Row>
          <Col md={6} data-aos="fade-right">
            <h2>About Us</h2>
            <p style={{textAlign:'justify'}}>
              At SHIVEK E-COMMERCE, our journey began with a simple goal: to make quality products easily accessible to everyone. Today, we are proud to be one of the most successful sellers online, offering a diverse range of products that cater to every need and lifestyle.
              Our business spans multiple categories, from electronics to home essentials, fashion, and health products. What sets us apart is our dedication to quality, customer satisfaction, and our ever-growing list of happy, repeat customers. With our presence on Amazon,  Flipkart, Meesho, and other major platforms, we bring our products to you wherever you shop.{" "}
            </p>
          </Col>
          <Col md={6} data-aos="fade-left">
            <Image src={ecommerceImg} alt="About Us" fluid />
          </Col>
        </Row>
      </Container>

      <Container className="my-5" id="categories">
        <h2 className="text-center mb-4">Our Product Categories</h2>
        <Row>
          <Col md={4} sm={6} data-aos="fade-in">
            <Card>
              <Card.Img variant="top" src={electronics} />
              <Card.Body>
                <Card.Title>Electronics</Card.Title>
                <Card.Text>
                  Gadgets, accessories, smart devices, and more.
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} data-aos="fade-in" data-aos-delay="100">
            <Card>
              <Card.Img variant="top" src={home} />
              <Card.Body>
                <Card.Title>Home & Kitchen</Card.Title>
                <Card.Text>
                  Appliances, cookware, home decor, and cleaning essentials. 
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} data-aos="fade-in" data-aos-delay="200">
            <Card>
              <Card.Img variant="top" src={fashion} />
              <Card.Body>
                <Card.Title>Fashion</Card.Title>
                <Card.Text>
                  Trendy clothing, footwear, and accessories for men and women.
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} data-aos="fade-in" data-aos-delay="300">
            <Card>
              <Card.Img variant="top" src={beauty} />
              <Card.Body>
                <Card.Title>Beauty & Personal Care</Card.Title>
                <Card.Text>
                  Skincare, haircare, and wellness products.
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} data-aos="fade-in" data-aos-delay="400">
            <Card>
              <Card.Img variant="top" src={toys} />
              <Card.Body>
                <Card.Title>Toys & Games</Card.Title>
                <Card.Text>
                  Fun and educational toys for kids of all ages.
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} data-aos="fade-in" data-aos-delay="500">
            <Card>
              <Card.Img variant="top" src={sports} />
              <Card.Body>
                <Card.Title>Sports & Fitness</Card.Title>
                <Card.Text>
                  Gear, apparel, and accessories for active living.
                </Card.Text>
                <Link to="/contact">
                  <Button variant="primary">Shop Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Container className="my-5" id="why-choose-us">
        <h2 className="text-center mb-4">Why Choose SHIVEK E-COMMERCE?</h2>
        <Row>
          <Col md={4} data-aos="fade-up">
            <h5>High-Quality Products</h5>
            <p>
              WHigh-Quality Products We offer only the best products from
              trusted brands and manufacturers, ensuring that each item meets
              the highest standards of quality.{" "}
            </p>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="200">
            <h5>Customer Satisfaction</h5>
            <p>
              Customer Satisfaction Our products are loved by customers! With
              high ratings and great reviews, our products are known for being
              reliable, well-made, and often re-purchased by loyal customers.{" "}
            </p>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="400">
            <h5>Competitive Pricing</h5>
            <p>
              At SHIVEK E-COMMERCE, we make sure that our products are
              affordable without compromising on quality. Our prices are highly
              competitive, making us a preferred choice among online shoppers.
            </p>
          </Col>
        </Row>
      </Container>

      <Container className="my-5" id="success-story">
        <Row>
          <Col>
            <h2 className="text-center">Our Success Story</h2>
            <p style={{textAlign:'justify'}}>
            In a short span, SHIVEK E-COMMERCE has achieved remarkable success as one
of the leading sellers in the online marketplace. Our dedication to providing top-
quality products and ensuring customer satisfaction has earned us a loyal
following. Customers appreciate our wide variety of products, fast delivery, and
hassle-free returns, leading to high customer retention and repeat purchases.
We are proud of our reputation as a trusted seller whose products consistently
meet customer expectations. {" "}
            </p>
          </Col>
        </Row>
      </Container>

      <Container className="my-5" id="contact-us">
        <Row>
          <Col>
            <h2 className="text-center">Contact Us</h2>
            <p>
            We’re always happy to assist you! Whether you have questions about our products,
need help with an order, or just want to know more about SHIVEK E-COMMERCE,
feel free to reach out to us.
            </p>
            <ul>
              <li>Email: shiveke@gmail.com</li>
              <li>Phone: 9424809020 </li>
              <li>Address: Bhopal, M.P.</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ecommerce;
